module.exports = __webpack_public_path__ + "img/8.0fe5f71e.jpg";